function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { ThemeProvider } from 'antd-style';
var AELFDProvider = function AELFDProvider(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, _extends({
    prefixCls: "aelfd"
  }, props, {
    customToken: function customToken(_ref) {
      var _props$customToken, _props$customToken2, _props$customToken3, _props$customToken4, _props$customToken5, _props$customToken6, _props$customToken7, _props$customToken8, _props$customToken9;
      var isDarkMode = _ref.isDarkMode;
      return {
        customButton: _objectSpread({}, (_props$customToken = props.customToken) === null || _props$customToken === void 0 ? void 0 : _props$customToken.customButton),
        customCollapse: _objectSpread({
          headerHoverBg: isDarkMode ? '#212121' : '#f8f8f8',
          headerClickBg: isDarkMode ? '#212121' : '#f8f8f8'
        }, (_props$customToken2 = props.customToken) === null || _props$customToken2 === void 0 ? void 0 : _props$customToken2.customCollapse),
        customTable: _objectSpread({
          headerBorderRadius: 6
        }, (_props$customToken3 = props.customToken) === null || _props$customToken3 === void 0 ? void 0 : _props$customToken3.customTable),
        customPagination: _objectSpread({
          colorTextSecondary: isDarkMode ? '#8C8C8C' : '#808080',
          colorBgHover: isDarkMode ? '#212121' : '#F8F8F8',
          colorDownArrow: isDarkMode ? '#FFFFFF' : '#101114'
        }, (_props$customToken4 = props.customToken) === null || _props$customToken4 === void 0 ? void 0 : _props$customToken4.customPagination),
        customAddress: _objectSpread({
          primaryLinkColor: isDarkMode ? '#127FFF' : '#1370DD',
          primaryIconColor: isDarkMode ? '#484848' : '#E0E0E0',
          addressHoverColor: isDarkMode ? '#3689DD' : '#3B9DFF',
          addressActiveColor: isDarkMode ? '#0756BC' : '#0460D9'
        }, (_props$customToken5 = props.customToken) === null || _props$customToken5 === void 0 ? void 0 : _props$customToken5.customAddress),
        customUpload: _objectSpread({
          borderColor: isDarkMode ? '#484848' : '#E0E0E0',
          containerBg: isDarkMode ? '#212121' : '#F8F8F8',
          colorFileText: isDarkMode ? '#fff' : '#070A26',
          colorMessageText: isDarkMode ? '#8C8C8C' : '#808080'
        }, (_props$customToken6 = props.customToken) === null || _props$customToken6 === void 0 ? void 0 : _props$customToken6.customUpload),
        customRichProgress: _objectSpread({
          colorText: isDarkMode ? '#e8e8e8' : '#1a1a1a',
          colorTextSecondary: isDarkMode ? '#808080' : '#8C8C8C',
          progressLineColor: isDarkMode ? '#1370DD' : '#127FFF',
          progressLineBg: isDarkMode ? '#353535' : '#F0f0f0',
          progressLineErrorColor: isDarkMode ? '#D43939' : '#F53F3F'
        }, (_props$customToken7 = props.customToken) === null || _props$customToken7 === void 0 ? void 0 : _props$customToken7.customRichProgress),
        customRadio: _objectSpread({
          dotColor: isDarkMode ? '#d07171' : '#FFFFFF'
        }, (_props$customToken8 = props.customToken) === null || _props$customToken8 === void 0 ? void 0 : _props$customToken8.customRadio),
        customCarousel: _objectSpread({
          colorNavigation: isDarkMode ? '#E8E8E8' : '#070A26',
          colorNavigationHover: isDarkMode ? '#fff' : '#22253E',
          colorNavigationActive: isDarkMode ? '#8C8C8C' : '#131631',
          colorMask: isDarkMode ? '#000000cc' : '#ffffffcc'
        }, (_props$customToken9 = props.customToken) === null || _props$customToken9 === void 0 ? void 0 : _props$customToken9.customCarousel)
      };
    },
    theme: function theme(appearance) {
      var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5, _props$theme6, _props$theme7, _props$theme8, _props$theme9, _props$theme10, _props$theme11, _props$theme12, _props$theme13, _props$theme14, _props$theme15, _props$theme16, _props$theme18;
      var comp = _objectSpread(_objectSpread({}, (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.components), {}, {
        Button: _objectSpread({
          colorPrimary: appearance === 'dark' ? '#1370DD' : '#127FFF'
        }, (_props$theme2 = props.theme) === null || _props$theme2 === void 0 || (_props$theme2 = _props$theme2.components) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.Button),
        Input: _objectSpread({
          paddingBlock: 11,
          paddingBlockSM: 7,
          paddingInline: 11,
          paddingInlineSM: 7,
          addonBg: appearance === 'dark' ? '#212121' : '#F8F8F8'
        }, (_props$theme3 = props.theme) === null || _props$theme3 === void 0 || (_props$theme3 = _props$theme3.components) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.Input),
        Collapse: _objectSpread({
          headerBg: appearance === 'dark' ? '#1A1A1A' : '#fff',
          contentPadding: '16px 24px',
          headerPadding: '16px 24px'
        }, props === null || props === void 0 || (_props$theme4 = props.theme) === null || _props$theme4 === void 0 || (_props$theme4 = _props$theme4.components) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.Collapse),
        Dropdown: _objectSpread({
          controlItemBgActiveHover: appearance === 'dark' ? '#212121' : '#F8F8F8'
        }, props === null || props === void 0 || (_props$theme5 = props.theme) === null || _props$theme5 === void 0 || (_props$theme5 = _props$theme5.components) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.Dropdown),
        Table: _objectSpread({
          headerBg: appearance === 'dark' ? '#353535' : '#F0F0F0',
          rowHoverBg: appearance === 'dark' ? '#212121' : '#F8F8F8',
          headerColor: appearance === 'dark' ? '#8C8C8C' : '#808080',
          fontWeightStrong: 500
        }, props === null || props === void 0 || (_props$theme6 = props.theme) === null || _props$theme6 === void 0 || (_props$theme6 = _props$theme6.components) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.Table),
        Modal: _objectSpread({
          paddingMD: 24,
          paddingContentHorizontalLG: 24,
          fontWeightStrong: 500,
          titleFontSize: 20,
          titleLineHeight: 1.4
        }, props === null || props === void 0 || (_props$theme7 = props.theme) === null || _props$theme7 === void 0 || (_props$theme7 = _props$theme7.components) === null || _props$theme7 === void 0 ? void 0 : _props$theme7.Modal),
        Tooltip: _objectSpread({
          colorBgSpotlight: appearance === 'dark' ? '#FFF' : '#282828',
          colorTextLightSolid: appearance === 'dark' ? '#808080' : '#8C8C8C',
          colorText: appearance === 'dark' ? '#808080' : '#8C8C8C',
          borderRadius: 8,
          fontSize: 12,
          lineHeight: 1.66666666666667,
          boxShadowSecondary: '0px 0px 16px 0px rgba(0, 0, 0, 0.16)'
        }, props === null || props === void 0 || (_props$theme8 = props.theme) === null || _props$theme8 === void 0 || (_props$theme8 = _props$theme8.components) === null || _props$theme8 === void 0 ? void 0 : _props$theme8.Tooltip),
        Tabs: _objectSpread({
          horizontalItemPadding: '17px 16px',
          horizontalItemPaddingSM: '13px 10px'
        }, props === null || props === void 0 || (_props$theme9 = props.theme) === null || _props$theme9 === void 0 || (_props$theme9 = _props$theme9.components) === null || _props$theme9 === void 0 ? void 0 : _props$theme9.Tabs),
        Radio: _objectSpread({
          dotSize: 8
        }, props === null || props === void 0 || (_props$theme10 = props.theme) === null || _props$theme10 === void 0 || (_props$theme10 = _props$theme10.components) === null || _props$theme10 === void 0 ? void 0 : _props$theme10.Radio),
        Progress: _objectSpread({
          remainingColor: appearance === 'dark' ? '#282828' : '#F5F5F5',
          colorSuccess: appearance === 'dark' ? '#1370DD' : '#127FFF',
          defaultColor: appearance === 'dark' ? '#1370DD' : '#127FFF'
        }, props === null || props === void 0 || (_props$theme11 = props.theme) === null || _props$theme11 === void 0 || (_props$theme11 = _props$theme11.components) === null || _props$theme11 === void 0 ? void 0 : _props$theme11.Progress),
        DatePicker: _objectSpread({
          cellWidth: 44,
          cellHeight: 24
        }, props === null || props === void 0 || (_props$theme12 = props.theme) === null || _props$theme12 === void 0 || (_props$theme12 = _props$theme12.components) === null || _props$theme12 === void 0 ? void 0 : _props$theme12.DatePicker),
        Tag: _objectSpread({
          defaultBg: appearance === 'dark' ? '#1370DD' : '#127FFF',
          defaultColor: appearance === 'dark' ? '#1A1A1A' : '#ffffff'
        }, props === null || props === void 0 || (_props$theme13 = props.theme) === null || _props$theme13 === void 0 || (_props$theme13 = _props$theme13.components) === null || _props$theme13 === void 0 ? void 0 : _props$theme13.Tag),
        Alert: _objectSpread({
          defaultPadding: '9px 12px',
          withDescriptionPadding: '24px 24px',
          colorIcon: appearance === 'dark' ? '#FFFFFF' : '#101114',
          colorIconHover: appearance === 'dark' ? '#F8F8F8' : '#212121'
        }, props === null || props === void 0 || (_props$theme14 = props.theme) === null || _props$theme14 === void 0 || (_props$theme14 = _props$theme14.components) === null || _props$theme14 === void 0 ? void 0 : _props$theme14.Alert),
        Breadcrumb: _objectSpread({
          itemColor: appearance === 'dark' ? '#8C8C8C' : '#808080',
          lastItemColor: appearance === 'dark' ? '#FFFFFF' : '#1A1A1A',
          linkColor: appearance === 'dark' ? '#8C8C8C' : '#808080',
          linkHoverColor: appearance === 'dark' ? '#FFFFFF' : '#1A1A1A',
          separatorColor: appearance === 'dark' ? '#8C8C8C' : '#808080'
        }, props === null || props === void 0 || (_props$theme15 = props.theme) === null || _props$theme15 === void 0 || (_props$theme15 = _props$theme15.components) === null || _props$theme15 === void 0 ? void 0 : _props$theme15.Breadcrumb),
        Slider: _objectSpread({
          handleLineWidth: 1,
          handleLineWidthHover: 2,
          handleSize: 10,
          // 1 + 10 + 1 = 12
          handleSizeHover: 12
        }, props === null || props === void 0 || (_props$theme16 = props.theme) === null || _props$theme16 === void 0 || (_props$theme16 = _props$theme16.components) === null || _props$theme16 === void 0 ? void 0 : _props$theme16.Slider)
      });
      var baseToken = {
        screenXXLMin: 1441,
        screenXLMax: 1440,
        screenLGMax: 1024,
        screenLGMin: 769,
        screenLG: 769,
        screenMDMax: 768,
        screenMDMin: 641,
        screenMD: 641,
        screenSMMax: 640,
        fontFamily: 'RobotoRegular,sans-serif'
      };
      if (appearance === 'dark') {
        var _props$theme17;
        return {
          token: _objectSpread(_objectSpread({
            colorPrimary: '#1370DD',
            colorPrimaryHover: '#3689DD',
            colorPrimaryActive: '#0756BC',
            colorError: '#D43939',
            colorErrorHover: '#E86262',
            colorErrorActive: '#B72C2C',
            colorErrorBorder: '#952626',
            colorInfo: '#1370DD',
            colorInfoBg: '#192737',
            colorInfoBorder: '#0A4D9C',
            colorSuccess: '#04A039',
            colorSuccessBg: '#172E1F',
            colorSuccessBorder: '#007026',
            colorWarning: '#DD8604',
            colorWarningBg: '#372A17',
            colorWarningBorder: '#9C5D00',
            colorLink: '#1370DD',
            colorLinkHover: '#3689DD',
            colorLinkActive: '#0756BC',
            colorTextBase: '#E8E8E8',
            colorBorder: '#484848',
            colorPrimaryBorder: '#484848',
            colorErrorBg: '#361F1F',
            colorTextDisabled: '#3D3D3D',
            controlItemBgActive: 'transparent',
            controlItemBgHover: '#212121',
            colorBgContainer: '#1A1A1A',
            colorBgElevated: '#282828',
            boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.16)',
            colorBgMask: 'rgba(0, 0, 0, 0.6)'
          }, baseToken), props === null || props === void 0 || (_props$theme17 = props.theme) === null || _props$theme17 === void 0 ? void 0 : _props$theme17.token),
          components: comp
        };
      }
      return {
        token: _objectSpread(_objectSpread({
          colorPrimary: '#127FFF',
          colorPrimaryHover: '#3B9DFF',
          colorPrimaryActive: '#0460D9',
          colorError: '#F53F3F',
          colorErrorHover: '#FC7373',
          colorErrorActive: '#CF3737',
          colorErrorBorder: '#FBB0B0',
          colorInfo: '#127FFF',
          colorInfoBg: '#E7F2FF',
          colorInfoBorder: '#9DCBFF',
          colorSuccess: '#00B73E',
          colorSuccessBg: '#E6F8EC',
          colorSuccessBorder: '#96E2B0',
          colorWarning: '#FF9900',
          colorWarningBg: '#FFF5E6',
          colorWarningBorder: '#FFD596',
          colorLink: '#127FFF',
          colorLinkHover: '#3B9DFF',
          colorLinkActive: '#0460D9',
          colorTextBase: '#1A1A1A',
          colorBorder: '#E0E0E0',
          colorErrorBg: '#FEE8E8',
          colorTextDisabled: '#010101',
          controlItemBgActive: 'transparent',
          controlItemBgHover: '#F8F8F8',
          colorBgContainer: '#FFFFFF',
          colorBgElevated: '#FFFFFF',
          boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.16)',
          colorBgMask: 'rgba(0, 0, 0, 0.6)'
        }, baseToken), props === null || props === void 0 || (_props$theme18 = props.theme) === null || _props$theme18 === void 0 ? void 0 : _props$theme18.token),
        components: comp
      };
    }
  }), props.children);
};
export default AELFDProvider;